import React, { createContext, useContext, ReactNode, useMemo } from 'react';
import { SharedFolderPublishData } from '../hooks/useSyncSocket';

interface SyncSocketContextValue {
  isSyncSocketConnected: boolean;
  sendSyncStart?: (pageNo: number) => void;
  sendQuizPublish?: (quizzes: any[], setUuid: string, setRevNo: number) => void;
  sendSharedFolderPublish?: (folderUuid: string, bookUuid: string, title: string) => void;
  receivedSharedFolder?: SharedFolderPublishData | null;
  clearReceivedSharedFolder?: () => void;
  showSyncLocationButton?: boolean;
  syncPendingPageNo?: number | null;
  onSyncLocationClick?: () => void;
}

const SyncSocketContext = createContext<SyncSocketContextValue | undefined>(undefined);

export const SyncSocketProvider: React.FC<{
  children: ReactNode;
  isSyncSocketConnected: boolean;
  sendSyncStart?: (pageNo: number) => void;
  sendQuizPublish?: (quizzes: any[], setUuid: string, setRevNo: number) => void;
  sendSharedFolderPublish?: (folderUuid: string, bookUuid: string, title: string) => void;
  receivedSharedFolder?: SharedFolderPublishData | null;
  clearReceivedSharedFolder?: () => void;
  showSyncLocationButton?: boolean;
  syncPendingPageNo?: number | null;
  onSyncLocationClick?: () => void;
}> = ({ children, isSyncSocketConnected, sendSyncStart, sendQuizPublish, sendSharedFolderPublish, receivedSharedFolder, clearReceivedSharedFolder, showSyncLocationButton, syncPendingPageNo, onSyncLocationClick }) => {
  //console.log('[SyncSocketContext] Provider 렌더링:', { showSyncLocationButton, syncPendingPageNo });
  
  const value: SyncSocketContextValue = React.useMemo(() => {
    const contextValue = {
      isSyncSocketConnected,
      sendSyncStart: sendSyncStart || undefined,
      sendQuizPublish: sendQuizPublish || undefined,
      sendSharedFolderPublish: sendSharedFolderPublish || undefined,
      receivedSharedFolder: receivedSharedFolder || null,
      clearReceivedSharedFolder: clearReceivedSharedFolder || undefined,
      showSyncLocationButton,
      syncPendingPageNo,
      onSyncLocationClick,
    };
    //console.log('[SyncSocketContext] useMemo 값 생성:', contextValue);
    return contextValue;
  }, [isSyncSocketConnected, sendSyncStart, sendQuizPublish, sendSharedFolderPublish, receivedSharedFolder, clearReceivedSharedFolder, showSyncLocationButton, syncPendingPageNo, onSyncLocationClick]);

  return (
    <SyncSocketContext.Provider value={value}>
      {children}
    </SyncSocketContext.Provider>
  );
};

export const useSyncSocketContext = (): SyncSocketContextValue => {
  const context = useContext(SyncSocketContext);
  
  //console.log('[useSyncSocketContext] 호출됨:', { hasContext: !!context, context });
  
  // Context가 없으면 기본값 반환 (경고 제거 - 초기 렌더링 시 정상적일 수 있음)
  if (!context) {
    //console.log('[useSyncSocketContext] Context 없음 - 기본값 반환');
    return { 
      isSyncSocketConnected: false,
      showSyncLocationButton: false,
      syncPendingPageNo: null,
    };
  }
  
  //console.log('[useSyncSocketContext] Context 반환:', context);
  return context;
};

